import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: "Llevaba dos años esperando un pago que creía perdido. Tras realizar el 'Ritual de Pago Bendecido' del capítulo 3, el dinero entró en mi cuenta a las 48 horas. No fue magia, fue dejar de repeler la abundancia con mi miedo. Este libro me devolvió la paz.",
  author: 'Marcela V.',
  location: 'México',
  image: 'https://cdn.magicpatterns.com/uploads/jpo5WAfkDEwHG2t1rwtVmS/www.thispersondoesnotexist.jpg'
}, {
  quote: 'Las discusiones con mi esposo por las deudas estaban destruyendo nuestro matrimonio. Este libro no solo sanó mis finanzas, salvó mi familia. Hoy el dinero fluye sin esfuerzo porque ya no peleamos con él, lo recibimos.',
  author: 'Carolina M.',
  location: 'España',
  image: 'https://cdn.magicpatterns.com/uploads/oKX2XtkMyJpBwYVxSTt4xm/www.thispersondoesnotexist.jpg'
}, {
  quote: "Sentía que tenía un 'techo de cristal'. Ganaba dinero pero nunca era suficiente. Con el bono de 'Guionismo de Realidades' entendí que mi propia narrativa me frenaba. El mes pasado cerré con mi facturación más alta y, por primera vez, sin pizca de ansiedad.",
  author: 'Lucía S.',
  location: 'Chile',
  image: 'https://cdn.magicpatterns.com/uploads/iwbXrh7DxJoE7dQ8uKAtDA/www.thispersondoesnotexist.jpg'
}, {
  quote: 'Vivía con un nudo en la garganta cada fin de mes. Entender que yo era quien bloqueaba mi propio jardín cambió todo. Ayer cerre el mejor mes de mi negocio con total calma y disfrutando de mi tiempo.',
  author: 'Andrea P.',
  location: 'España',
  image: 'https://cdn.magicpatterns.com/uploads/iWMUUKkq9KPTHfYFTHoEX8/www.thispersondoesnotexist.jpg'
}];
export function Testimonials() {
  return <section className="py-24 bg-[#F9F9F7]" data-id="element-194">
      <div className="max-w-6xl mx-auto px-6" data-id="element-195">
        <div className="text-center mb-20" data-id="element-196">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 py-2 px-4 rounded-full bg-white border border-[#C5A059]/30 shadow-sm mb-8" data-id="element-197">
            <Star className="w-4 h-4 fill-[#C5A059] text-[#C5A059]" data-id="element-198" />
            <span className="text-stone-800 text-sm font-semibold tracking-wide" data-id="element-199">
              4.9/5 Calificación
            </span>
            <span className="text-stone-400 text-sm" data-id="element-200">| +4,500 mujeres</span>
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-serif text-stone-900 mb-6" data-id="element-201">
            Historias de Transformación
          </h2>
          <div className="w-12 h-[1px] bg-[#C5A059] mx-auto" data-id="element-202"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16 gap-y-12" data-id="element-203">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative flex flex-col" data-id="element-204">
              <Quote className="w-8 h-8 text-[#C5A059] opacity-20 mb-4" data-id="element-205" />
              <p className="text-stone-700 text-xl font-serif italic mb-8 leading-relaxed flex-grow" data-id="element-206">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-stone-200/60" data-id="element-207">
                <img src={testimonial.image} alt={`Fotografía de ${testimonial.author}`} className="w-12 h-12 rounded-full object-cover border border-stone-200/60 shadow-sm" data-id="element-208" />
                <div data-id="element-209">
                  <p className="font-semibold text-stone-900 tracking-wide" data-id="element-210">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-stone-500 uppercase tracking-widest mt-1" data-id="element-211">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-16 text-center" data-id="element-212">
          <p className="text-xs md:text-sm text-stone-400 italic max-w-2xl mx-auto" data-id="element-213">
            * Estos resultados son el reflejo del compromiso de cada mujer con
            su propia reprogramación. Los cambios internos preceden siempre a
            los cambios externos.
          </p>
        </motion.div>
      </div>
    </section>;
}